import { Injectable } from '@angular/core';
import { SpinnerState } from '@core/states/spinner.state';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';


@AttachYCState(SpinnerState)
@Injectable({ providedIn: 'root' })
export class SpinnerService extends BaseYCService<SpinnerState> {

  get loading () {
    return this.get('loading');
  }

  startSpinner () {
    this.set('loading', true);
  }

  stopSpinner () {
    this.set('loading', false);
  }

  setLoadingMessage (message: string) {
    this.set('loadingMessage', message);
  }
}
